import i18n from '../../utils/i18n';

export const generateInputParamsAttributes = supplyType => [
	{
		label: supplyType === 'DC' ? 'Vin' : 'Vin rms',
		formattedLabel: supplyType === 'DC' ? 'V<sub>IN</sub>' : 'V<sub>IN(rms)</sub>',
		value: 'vin',
		unit: 'V'
	},
	{
		label: 'Vout',
		formattedLabel: 'V<sub>OUT</sub>',
		value: 'vout',
		unit: 'V'
	},
	{
		label: 'Iout',
		formattedLabel: 'I<sub>OUT</sub>',
		value: 'iout',
		unit: 'A'
	},
	{
		label: i18n.t('components.inputParameters.params.ambientTemp'),
		formattedLabel: `T<sub>${i18n.t('components.inputParameters.formattedLabel.ambient')}</sub>`,
		value: 'ambientTemperature',
		unit: '\u00B0C'
	},
	{
		label: i18n.t('components.inputParameters.params.supplyType'),
		formattedLabel: i18n.t('components.inputParameters.params.supplyType'),
		value: 'supplyType',
		unit: ''
	},
	{
		label: i18n.t('components.inputParameters.params.outputIsolation'),
		formattedLabel: i18n.t('components.inputParameters.params.outputIsolation'),
		value: 'isolated',
		unit: ''
	},
	{
		label: i18n.t('components.inputParameters.params.qualification'),
		formattedLabel: i18n.t('components.inputParameters.params.qualification'),
		value: 'automotiveDesign',
		unit: ''
	}
];

export const generateInputParamsAttributesOptional = supplyType => [
	{
		label: supplyType === 'DC' ? 'Vin nom' : 'Vin rms nom',
		value: 'vinNom',
		unit: 'V'
	}
];

export const generateInputParamsAttributesPdf = supplyType => [
	{
		label: supplyType === 'DC' ? 'Vin min' : 'Vin rms min',
		formattedLabel: supplyType === 'DC' ? 'V<sub>IN(min)</sub>' : 'V<sub>IN(rms min)</sub>',
		value: 'vinMin',
		unit: 'V'
	},
	{
		label: supplyType === 'DC' ? 'Vin max' : 'Vin rms max',
		formattedLabel: supplyType === 'DC' ? 'V<sub>IN(max)</sub>' : 'V<sub>IN(rms max)</sub>',
		value: 'vinMax',
		unit: 'V'
	},
	{
		label: supplyType === 'DC' ? 'Vin nom' : 'Vin rms nom',
		formattedLabel: supplyType === 'DC' ? 'V<sub>IN(nom)</sub>' : 'V<sub>IN(rms nom)</sub>',
		value: 'vinNom',
		unit: 'V'
	},
	{
		label: 'Vout',
		formattedLabel: 'V<sub>OUT</sub>',
		value: 'vout',
		unit: 'V'
	},
	{
		label: 'Iout',
		formattedLabel: 'I<sub>OUT</sub>',
		value: 'iout',
		unit: 'A'
	},
	{
		label: i18n.t('components.inputParameters.params.ambientTemp'),
		formattedLabel: `T<sub>${i18n.t('components.inputParameters.formattedLabel.ambient')}</sub>`,
		value: 'ambientTemperature',
		unit: '\u00B0C'
	},
	{
		label: i18n.t('components.inputParameters.params.supplyType'),
		formattedLabel: i18n.t('components.inputParameters.params.supplyType'),
		value: 'supplyType',
		unit: ''
	},
	{
		label: i18n.t('components.inputParameters.params.outputIsolation'),
		formattedLabel: i18n.t('components.inputParameters.params.outputIsolation'),
		value: 'output',
		unit: ''
	}
];
